import React from "react";
import { scrollToSection } from "../utils/scroll";
const links = [{
  label: "El método",
  href: "#metodo"
}, {
  label: "Para quién",
  href: "#para-quien"
}, {
  label: "Contenido",
  href: "#contenido"
}, {
  label: "Bonus",
  href: "#bonus"
}];
export function Header() {
  return <>
      <header className="sticky top-0 z-40 border-b border-line bg-ink/85 backdrop-blur" data-id="element-75" data-mp="2nl3i1a51ekbg">
        <div className="mx-auto flex max-w-6xl flex-col items-center gap-2.5 px-6 py-4 text-center" data-id="element-76" data-mp="2rmf79ek013j4">
          <a href="#top" className="whitespace-nowrap font-serif text-lg font-semibold text-cream md:text-xl" data-id="element-77" data-mp="2wkqjtx1ohs51">
            Mindset <span className="text-gold" data-id="element-78" data-mp="31d05v1zoa821">Anti-Fragilidad</span>
          </a>
          <nav aria-label="Secciones" className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1 md:gap-x-8" data-id="element-79" data-mp="36as8apxy1ckh">
            {links.map(link => <a key={link.href} href={link.href} className="whitespace-nowrap text-xs font-medium text-muted transition-colors duration-150 hover:text-cream md:text-sm" data-id="element-80" data-mp="3bbzfonw6c9qm">
                {link.label}
              </a>)}
          </nav>
        </div>
      </header>

      <aside aria-label="Oferta de lanzamiento" className="border-b border-line bg-emerald-deep" data-id="element-81" data-mp="2mmetqmk9a1uo">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-center gap-2.5 px-6 py-4 text-center md:flex-row md:gap-6" data-id="element-82" data-mp="2hntvgsokds8v">
          <p className="text-xs font-medium text-gold" data-id="element-83" data-mp="3fa10g3os5mlr">Precio de lanzamiento</p>
          <p className="flex items-baseline justify-center gap-2.5" data-id="element-84" data-mp="3abzgzhnfzl9r">
            <span className="text-sm text-muted line-through" data-id="element-85" data-mp="35lj1zt3z3rla">$10.990</span>
            <span className="text-xl font-semibold text-gold-light" data-id="element-86" data-mp="35jg1gf572g2b">$4.990 ARS</span>
          </p>
          <a href="#comprar" onClick={event => scrollToSection(event, "comprar", "center")} className="whitespace-nowrap rounded-full bg-gold px-8 py-2.5 text-sm font-semibold text-ink transition-[background-color,transform] duration-150 ease-out hover:bg-gold-light active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-emerald-deep" data-id="element-87" data-mp="30kda1xi508ct">
            Acceder por $4.990
          </a>
        </div>
      </aside>
    </>;
}